import { IHttpExceptionDetail } from "@/lib/exceptions/http";
import { HttpExceptionDetailMapper } from "@/services/AxiosErrorToExceptionHandler";
import { MrfiktivXInvoiceValidationReportViewModelGen } from "../v1/data-contracts";

/**
 * Exception detail for invoice endpoints. Printing can fail X-Invoice/ZUGFeRD schema or schematron
 * validation, which reports every violated rule (`MrfiktivXInvoiceValidationErrorViewModelGen.report`)
 * instead of a single flat message.
 */
export type IInvoiceHttpExceptionDetail = IHttpExceptionDetail & {
  report?: MrfiktivXInvoiceValidationReportViewModelGen;
};

/**
 * Maps invoice error responses the same way as the app-wide {@link HttpExceptionDetailMapper}, but
 * also keeps the X-Invoice validation report that mapper drops, so the invoice UI can show every
 * violated rule instead of just the summary message.
 */
export class InvoiceHttpExceptionDetailMapper extends HttpExceptionDetailMapper {
  public map(data: any): IInvoiceHttpExceptionDetail | undefined {
    const mapped = super.map(data);
    if (mapped && data?.report) {
      (mapped as IInvoiceHttpExceptionDetail).report = data.report;
    }

    return mapped;
  }
}
